// Suivi de conversions — respecte le consentement (RGPD).
// Les événements ne sont poussés que si l'utilisateur a accepté les cookies de mesure.
// Compatible Google Tag Manager (window.dataLayer) et gtag si présents.

export const CONSENT_KEY = "frelons50_consent";

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}

export function trackEvent(event, params = {}) {
  const consent = getConsent();
  if (!consent || !consent.analytics) return; // pas de suivi sans consentement
  const payload = { event, ...params };
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  }
}
